import { render, staticRenderFns } from "./EmailUnbestaetigt.vue?vue&type=template&id=87e8e724"
import script from "./EmailUnbestaetigt.vue?vue&type=script&lang=js"
export * from "./EmailUnbestaetigt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports